import React from 'react';
import SavedPlacementsContainer from './SavedPlacementsContainer';

interface Props {}

function SavedPlacementsTab({}: Props) {
	return <SavedPlacementsContainer />;
}

export default SavedPlacementsTab;
